module.exports = __webpack_public_path__ + "img/logo.rgb.black.d1e269c9.png";